// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27none%27 stroke=%27white%27 stroke-width=%272%27 d=%27m2 6 2.5 2.5L10 3%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/images/auth/orb-top-left.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/images/auth/orb-top-right.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/images/auth/orb-large.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/images/auth/orb-mobile-left.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/images/auth/orb-mobile-right.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --auth-brand-start: var(--brand-gradient-start);
  --auth-brand-mid: var(--brand-gradient-mid);
  --auth-brand-end: var(--brand-gradient-end);
  --auth-text-primary: var(--text-primary);
  --auth-text-secondary: var(--text-secondary);
  --auth-text-disabled: var(--text-secondary);
  --auth-interactive: var(--interactive-default);
  --auth-interactive-hover: var(--interactive-hover);
  --auth-danger: var(--danger-default);
  --auth-border: var(--border-default);
  --auth-border-subtle: var(--border-subtle);
  --auth-surface-secondary: var(--surface-secondary);
  --auth-radius-md: var(--radius-md);
  --auth-radius-lg: var(--radius-lg);
  --auth-font: var(--font-family-primary);
}
* {
  box-sizing: border-box;
}
.auth-page {
  min-height: 100vh;
  display: flex;
  background: var(--surface-primary);
  font-family: var(--auth-font);
  color: var(--auth-text-primary);
}
.auth-brand {
  position: relative;
  flex: 1 1 50%;
  min-width: 0;
  min-height: 100vh;
  padding: 80px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: linear-gradient(
    90deg,
    var(--auth-brand-start),
    var(--auth-brand-mid) 45%,
    var(--auth-brand-end)
  );
  color: #fff;
}
.auth-brand__logo {
  position: relative;
  z-index: 1;
  width: 262px;
  height: 57px;
}
.auth-brand__mobile-logo {
  display: none;
}
.auth-brand__message {
  position: relative;
  z-index: 1;
  display: grid;
  gap: 24px;
}
.auth-brand__message h1 {
  margin: 0;
  max-width: 720px;
  font-size: 54px;
  line-height: 64px;
  letter-spacing: -2px;
  font-weight: 700;
}
.auth-brand__message p {
  margin: 0;
  max-width: 760px;
  font-size: 18px;
  line-height: 28.8px;
}
.auth-brand__features {
  position: relative;
  z-index: 1;
  display: flex;
  gap: 16px;
}
.auth-feature {
  min-width: 0;
  flex: 0 1 230px;
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: var(--auth-radius-lg);
  background: rgba(255, 255, 255, 0.1);
  display: grid;
  gap: 2px;
}
.auth-feature__icon {
  width: 32px;
  height: 32px;
  margin-bottom: 10px;
  display: grid;
  place-items: center;
  border-radius: var(--auth-radius-md);
  background: rgba(255, 255, 255, 0.13);
}
.auth-feature__icon img {
  width: 18px;
  height: 18px;
}
.auth-feature strong {
  font-size: 16px;
  line-height: 20.8px;
  font-weight: 500;
  white-space: nowrap;
}
.auth-feature small {
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  line-height: 16.8px;
  white-space: nowrap;
}
.auth-orb {
  position: absolute;
  display: block;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
}
.auth-orb--one {
  width: 516px;
  height: 516px;
  left: -178px;
  top: -205px;
}
.auth-orb--two {
  width: 140px;
  height: 140px;
  left: 666px;
  right: auto;
  top: -60px;
}
.auth-orb--three {
  width: 416px;
  height: 416px;
  left: 528px;
  right: auto;
  top: 758px;
  bottom: auto;
  background: rgba(5, 78, 104, 0.12);
}
.auth-panel {
  flex: 1 1 50%;
  min-width: 0;
  min-height: 100vh;
  position: relative;
  padding: 64px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  background: var(--surface-primary);
}
.auth-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.auth-title {
  display: grid;
  gap: 8px;
}
.auth-title h2 {
  margin: 0;
  font-weight: 300;
  font-size: 48px;
  line-height: 55.2px;
  letter-spacing: -0.96px;
}
.auth-title p {
  margin: 0;
  color: var(--auth-text-secondary);
  font-size: 14px;
  line-height: 21.7px;
}
.auth-inputs {
  display: grid;
  gap: 16px;
}
.auth-field {
  display: grid;
  gap: 6px;
}
.auth-field__label-row {
  display: flex;
  align-items: center;
  min-height: 18px;
}
.auth-field label {
  font-size: 14px;
  line-height: 18px;
  font-weight: 500;
}
.auth-field label span {
  color: var(--auth-danger);
}
.auth-field__action {
  margin-left: auto;
  border: 0;
  padding: 0;
  color: var(--auth-interactive);
  background: none;
  font: 400 14px/18px var(--auth-font);
  cursor: pointer;
  text-decoration: none;
}
.auth-control {
  width: 100%;
  height: 48px;
  border: 1px solid var(--border-strong);
  border-radius: var(--auth-radius-lg);
  padding: 0 16px;
  outline: none;
  color: var(--auth-text-primary);
  background: var(--surface-primary);
  font: 400 16px var(--auth-font);
}
.auth-control::placeholder {
  color: var(--auth-text-disabled);
  opacity: 1;
}
.auth-control:hover:not(:disabled):not(:focus) {
  border-color: var(--border-strong);
}
.auth-control:focus {
  border-width: 2px;
  border-color: var(--auth-interactive);
  box-shadow: none;
}
.auth-control--error {
  border-color: var(--auth-danger);
}
.auth-password {
  position: relative;
}
.auth-password .auth-control {
  padding-right: 48px;
}
.auth-password__toggle {
  position: absolute;
  right: 13px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  padding: 2px;
  border: 0;
  background: none;
  cursor: pointer;
}
.auth-password__toggle img {
  width: 20px;
  height: 20px;
}
.auth-field__error {
  color: var(--auth-danger);
  font-size: 12px;
  line-height: 16px;
}
.auth-check {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--auth-text-secondary);
  font-size: 14px;
  cursor: pointer;
}
.auth-check input {
  appearance: none;
  width: 20px;
  height: 20px;
  margin: 0;
  border: 1.5px solid var(--auth-border);
  border-radius: 4px;
  background: var(--surface-primary);
  cursor: pointer;
}
.auth-check input:checked {
  border-color: var(--auth-interactive);
  background: var(--auth-interactive)
    url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    center/12px no-repeat;
}
.auth-actions {
  display: grid;
  gap: 14px;
}
.auth-button {
  height: 48px;
  border: 0;
  border-radius: var(--auth-radius-lg);
  padding: 0 24px;
  font: 500 16px var(--auth-font);
  cursor: pointer;
}
.auth-button--primary {
  color: var(--on-interactive-primary);
  background: var(--auth-interactive);
}
.auth-button--primary:hover {
  background: var(--auth-interactive-hover);
}
.auth-button--loading {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  cursor: wait !important;
  opacity: 0.85;
  pointer-events: none;
}
.auth-button__spinner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: auth-button-spin 0.65s linear infinite;
  margin-right: 8px;
  flex: 0 0 18px;
}
@keyframes auth-button-spin {
  to {
    transform: rotate(360deg);
  }
}
.auth-divider {
  height: 1px;
  background: var(--auth-border-subtle);
}
.auth-button--secondary {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--auth-text-primary);
  border: 1px solid var(--auth-border);
  background: var(--auth-surface-secondary);
}
.auth-button--secondary img {
  width: 20px;
  height: 20px;
}
.auth-signup {
  display: flex;
  justify-content: center;
  gap: 4px;
  margin: 0;
  color: var(--auth-text-secondary);
  font-size: 14px;
  line-height: 21.7px;
}
.auth-link {
  color: var(--auth-interactive);
  text-decoration: none;
  font-weight: 500;
}
.auth-legal {
  position: absolute;
  bottom: 32px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 4px;
  color: var(--auth-text-secondary);
  font-size: 13px;
  white-space: nowrap;
}
.auth-legal a {
  color: var(--auth-interactive);
  text-decoration: none;
}
@media (min-width: 1024px) and (max-width: 1579px) {
  .auth-page--login .auth-brand {
    padding-inline: clamp(32px, 5vw, 64px);
  }
  .auth-page--login .auth-brand__message h1 {
    font-size: clamp(38px, 3.4vw, 48px);
    line-height: 1.12;
    letter-spacing: -1.2px;
  }
  .auth-page--login .auth-brand__features {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: clamp(8px, 1vw, 14px);
  }
  .auth-page--login .auth-feature {
    min-width: 0;
    padding: clamp(10px, 1vw, 14px);
  }
  .auth-page--login .auth-feature strong {
    font-size: clamp(12px, 0.9vw, 14px);
    line-height: 1.35;
    white-space: normal;
    overflow-wrap: anywhere;
  }
  .auth-page--login .auth-feature small {
    font-size: clamp(10px, 0.76vw, 12px);
    line-height: 1.4;
    white-space: normal;
    overflow-wrap: anywhere;
  }
}
@media (max-width: 1023px) {
  .auth-page {
    flex-direction: column;
  }
  .auth-brand {
    flex: none;
    width: 100%;
    min-height: 282px;
    padding: 54px 48px 48px;
    gap: 24px;
    justify-content: flex-start;
  }
  .auth-brand__message {
    gap: 12px;
  }
  .auth-brand__message h1 {
    font-size: 36px;
    line-height: 44px;
    letter-spacing: -1.5px;
  }
  .auth-brand__message p {
    max-width: 700px;
    font-size: 15px;
    line-height: 22px;
    opacity: 0.9;
  }
  .auth-brand__features {
    display: none;
  }
  .desktop-only {
    display: none;
  }
  .auth-orb--one {
    width: 380px;
    height: 380px;
    left: -100px;
    top: -120px;
  }
  .auth-orb--two {
    width: 74px;
    height: 74px;
    left: 736px;
    right: auto;
    top: -38px;
  }
  .auth-orb--three {
    width: 300px;
    height: 300px;
    left: 520px;
    right: auto;
    top: 110px;
    bottom: auto;
  }
  .auth-panel {
    flex: none;
    width: 100%;
    min-height: 742px;
    padding: 85px 80px 56px;
    justify-content: flex-start;
    gap: 32px;
  }
  .auth-form {
    flex: 1 1;
  }
  .auth-title h2 {
    font-size: 40px;
    line-height: 46px;
    letter-spacing: -0.8px;
  }
  .auth-title p,
  .auth-signup {
    font-size: 13px;
    line-height: 20.2px;
  }
  .auth-inputs {
    gap: 20px;
  }
  .auth-field label,
  .auth-field__action {
    font-size: 13px;
  }
  .auth-control {
    height: 40px;
    padding: 0 12px;
    border-color: var(--auth-border);
    border-radius: var(--auth-radius-md);
    font-size: 14px;
  }
  .auth-actions {
    gap: 16px;
  }
  .auth-button {
    height: 44px;
    padding: 0 16px;
    border-radius: var(--auth-radius-md);
    font-size: 14px;
  }
  .auth-legal {
    position: static;
    transform: none;
    justify-content: center;
    padding-top: 24px;
  }
}
@media (max-width: 600px) {
  .auth-page {
    min-height: 812px;
    position: relative;
    padding-top: 227px;
    background: linear-gradient(
      90deg,
      var(--auth-brand-start),
      var(--auth-brand-mid) 45%,
      var(--auth-brand-end)
    );
  }
  .auth-brand {
    position: absolute;
    inset: 0 0 auto;
    height: 227px;
    min-height: 227px;
    padding: 48px 20px 0;
    align-items: center;
    background: transparent;
  }
  .auth-brand__logo,
  .auth-brand__message {
    display: none;
  }
  .auth-brand__mobile-logo {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }
  .auth-brand__mobile-logo img:first-child {
    width: 57px;
    height: 57px;
  }
  .auth-brand__mobile-logo img:last-child {
    width: 196px;
    height: 21px;
  }
  .auth-orb--one {
    width: 236px;
    height: 236px;
    left: -82px;
    top: -56px;
  }
  .auth-orb--two {
    width: 126px;
    height: 126px;
    right: -56px;
    top: -53px;
  }
  .auth-orb--three {
    display: none;
  }
  .auth-panel {
    position: relative;
    z-index: 2;
    min-height: 585px;
    padding: 32px 24px;
    border-radius: 32px 32px 0 0;
  }
  .auth-form {
    gap: 32px;
  }
  .auth-title h2 {
    font-size: 32px;
    line-height: 36.8px;
    letter-spacing: -0.64px;
  }
  .auth-check {
    gap: 6px;
    font-size: 13px;
  }
  .auth-check input {
    width: 16px;
    height: 16px;
  }
  .auth-button {
    height: 40px;
    padding: 0 12px;
    font-size: 13px;
  }
  .auth-button--secondary img {
    width: 16px;
    height: 16px;
  }
  .auth-signup {
    gap: 6px;
    white-space: nowrap;
  }
  .auth-legal {
    padding-top: 24px;
    gap: 8px;
  }
}
@media (max-width: 374px) {
  .auth-panel {
    padding-left: 20px;
    padding-right: 20px;
  }
  .auth-signup {
    white-space: normal;
    flex-wrap: wrap;
  }
}
.auth-orb {
  border-radius: 0;
  background: center/contain no-repeat;
}
.auth-orb--one {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.auth-orb--two {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.auth-orb--three {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@media (max-width: 600px) {
  .auth-orb--one {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  }
  .auth-orb--two {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  }
}

/* Forgot-password composition */
.auth-panel--reset {
  flex: 0 0 50%;
  width: 50%;
}
.auth-form--reset {
  height: 512px;
}
.auth-email-control {
  position: relative;
}
.auth-email-control > img {
  display: none;
  position: absolute;
  z-index: 1;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
}
.auth-actions--reset {
  gap: 20px;
}
.auth-back-link {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: var(--auth-radius-lg);
  color: var(--auth-interactive);
  font: 500 16px var(--auth-font);
  text-decoration: none;
}
.auth-back-link img {
  width: 20px;
  height: 20px;
}
@media (max-width: 1023px) {
  .auth-page--reset .auth-panel--reset {
    flex: 1 1;
    width: 100%;
  }
  .auth-form--reset {
    height: auto;
  }
  .auth-email-control > img {
    display: block;
  }
  .auth-email-control .auth-control {
    padding-left: 40px;
  }
  .auth-actions--reset {
    gap: 16px;
  }
  .auth-back-link {
    height: 44px;
    border-radius: var(--auth-radius-md);
    font-size: 14px;
  }
}
@media (max-width: 600px) {
  .auth-page--reset .auth-panel--reset {
    height: 585px;
    min-height: 585px;
    overflow: hidden;
    justify-content: space-between;
  }
  .auth-page--reset .auth-form--reset {
    flex: none;
  }
  .auth-page--reset .auth-field {
    gap: 4px;
  }
  .auth-page--reset .auth-control {
    height: 32px;
    padding-left: 34px;
    padding-right: 10px;
    font-size: 13px;
  }
  .auth-page--reset .auth-email-control > img {
    left: 10px;
    width: 16px;
    height: 16px;
  }
  .auth-page--reset .auth-back-link {
    height: 40px;
    gap: 6px;
    font-size: 13px;
  }
  .auth-page--reset .auth-back-link img {
    width: 16px;
    height: 16px;
  }
}

/* Reset-link confirmation */
.auth-panel--confirmation {
  align-items: center;
}
.auth-confirmation {
  width: 480px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-8);
  text-align: center;
}
.auth-success-ring {
  width: 64px;
  height: 64px;
  display: grid;
  place-items: center;
  border-radius: var(--radius-full);
  background: var(--interactive-soft);
}
.auth-success-ring img {
  width: 24px;
  height: 24px;
}
.auth-confirmation__title {
  width: 100%;
  display: grid;
  gap: var(--space-3);
}
.auth-confirmation__title h2 {
  margin: 0;
  color: var(--text-primary);
  font: var(--font-weight-light) var(--font-size-display-lg) /
    var(--line-height-display-lg) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-display-lg);
}
.auth-confirmation__title p {
  margin: 0;
  color: var(--text-secondary);
  font: var(--font-weight-regular) var(--font-size-body-sm) /
    var(--line-height-body-sm) var(--font-family-primary);
}
.auth-confirmation__title strong {
  color: var(--text-primary);
  font-weight: var(--font-weight-bold);
}
.auth-confirmation__actions {
  width: 100%;
  display: grid;
  gap: var(--space-4);
}
.auth-confirmation__actions p {
  margin: 0;
  color: var(--text-tertiary);
  font: var(--font-weight-regular) var(--font-size-caption-md) /
    var(--line-height-caption-md) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-caption-md);
}
.auth-confirmation > .auth-divider {
  width: 100%;
}

/* Set-new-password composition */
.auth-form--new-password {
  gap: var(--space-8);
}
.auth-field__hint {
  height: 16px;
  color: var(--text-secondary);
  font: var(--font-weight-regular) var(--font-size-caption-md) / 16px
    var(--font-family-primary);
}
.auth-actions--new-password {
  gap: var(--space-6);
}
.auth-button:disabled {
  cursor: not-allowed;
  background: var(--interactive-disabled);
  color: var(--on-interactive-disabled);
}

@media (max-width: 1023px) {
  .auth-panel--confirmation {
    justify-content: flex-start;
  }
  .auth-confirmation {
    width: 100%;
    max-width: 500px;
    flex: 1 1;
  }
  .auth-panel--new-password {
    justify-content: flex-start;
  }
  .auth-form--new-password {
    flex: 1 1;
  }
  .auth-actions--new-password {
    gap: var(--space-6);
  }
}
@media (max-width: 600px) {
  .auth-page--confirmation .auth-panel--confirmation,
  .auth-page--new-password .auth-panel--new-password {
    height: 585px;
    min-height: 585px;
    justify-content: space-between;
    overflow: hidden;
  }
  .auth-page--confirmation .auth-confirmation {
    flex: 1 1;
    gap: var(--space-8);
  }
  .auth-page--confirmation .auth-legal,
  .auth-page--new-password .auth-legal {
    flex: none;
  }
  .auth-confirmation__title p {
    max-width: 327px;
  }
  .auth-page--new-password .auth-form--new-password {
    flex: none;
  }
  .auth-page--new-password .auth-inputs {
    gap: var(--space-4);
  }
  .auth-page--new-password .auth-field {
    gap: var(--space-1);
  }
  .auth-page--new-password .auth-control {
    height: var(--control-sm);
    padding-left: 10px;
    padding-right: 36px;
    font-size: var(--font-size-body-sm);
  }
  .auth-page--new-password .auth-password__toggle {
    right: 8px;
    width: 20px;
    height: 20px;
  }
  .auth-page--new-password .auth-password__toggle img {
    width: 16px;
    height: 16px;
  }
  .auth-page--new-password .auth-actions--new-password {
    gap: var(--space-6);
  }
}

/* Password-reset success */
.auth-panel--password-success {
  align-items: center;
}
.auth-password-success {
  width: 440px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-8);
  text-align: center;
}
.auth-password-success__icon {
  width: 72px;
  height: 72px;
  display: grid;
  place-items: center;
  border-radius: var(--radius-full);
  background: var(--interactive-soft);
}
.auth-password-success__icon img {
  width: 22px;
  height: 22px;
}
.auth-password-success__copy {
  width: 100%;
  display: grid;
  gap: var(--space-3);
}
.auth-password-success__copy h2,
.auth-password-success__copy p {
  margin: 0;
}
.auth-password-success__copy h2 {
  color: var(--text-primary);
  font: var(--font-weight-light) var(--font-size-display-lg) /
    var(--line-height-display-lg) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-display-lg);
}
.auth-password-success__copy p {
  color: var(--text-secondary);
  font: var(--font-weight-regular) var(--font-size-body-sm) /
    var(--line-height-body-sm) var(--font-family-primary);
}

@media (max-width: 1023px) {
  .auth-panel--password-success {
    justify-content: flex-start;
  }
  .auth-password-success {
    width: 100%;
    max-width: 500px;
    flex: 1 1;
  }
  .auth-password-success__copy h2 {
    font-size: 40px;
    line-height: 46px;
    letter-spacing: -0.8px;
  }
  .auth-password-success__copy p {
    font-size: 13px;
    line-height: 20.2px;
  }
}

@media (max-width: 600px) {
  .auth-page--password-success .auth-panel--password-success {
    height: 585px;
    min-height: 585px;
    justify-content: space-between;
    overflow: hidden;
  }
  .auth-page--password-success .auth-password-success {
    flex: 1 1;
  }
  .auth-password-success__copy h2 {
    font-size: 32px;
    line-height: 36.8px;
    letter-spacing: -0.64px;
  }
  .auth-page--password-success .auth-legal {
    flex: none;
  }
}

/* Sign-up */
.auth-page--signup .auth-brand {
  flex: 0 0 51.111%;
}
.auth-panel--signup {
  flex: 1 1 auto;
  align-items: stretch;
}
.auth-signup-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}
.auth-signup-inputs {
  display: grid;
  gap: var(--space-4);
}
.auth-terms-check {
  min-height: 24px;
  display: flex;
  align-items: flex-start;
  gap: var(--space-2);
  color: var(--text-primary);
  font: var(--font-weight-regular) var(--font-size-body-sm) /
    var(--line-height-body-sm) var(--font-family-primary);
  cursor: pointer;
}
.auth-terms-check input {
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  margin: 2px 0 0;
  accent-color: var(--interactive-default);
}
.auth-terms-check a,
.auth-signup-login a,
.auth-text-button {
  color: var(--interactive-default);
}
.auth-terms-check a {
  text-decoration: underline;
}
.auth-signup-login {
  margin: 0;
  text-align: center;
  color: var(--text-secondary);
  font: var(--font-weight-regular) var(--font-size-body-sm) /
    var(--line-height-body-sm) var(--font-family-primary);
}
.auth-signup-login a {
  margin-left: var(--space-1);
  font-weight: var(--font-weight-medium);
  text-decoration: none;
}
.auth-signup-form--otp {
  gap: var(--space-8);
}
.auth-signup-otp-actions {
  display: grid;
  gap: var(--space-4);
}
.auth-text-button {
  border: 0;
  background: transparent;
  font: var(--font-weight-medium) var(--font-size-label-md) /
    var(--line-height-label-md) var(--font-family-primary);
  cursor: pointer;
}

@media (max-width: 1023px) {
  .auth-page--signup .auth-brand {
    flex: none;
  }
  .auth-panel--signup {
    gap: var(--space-8);
  }
  .auth-signup-form {
    gap: var(--space-8);
  }
  .auth-signup-inputs {
    gap: var(--space-5);
  }
  .auth-panel--signup .auth-control {
    height: 40px;
    padding: 0 12px;
    border-color: var(--border-default);
    border-radius: var(--radius-md);
    font-size: 14px;
  }
  .auth-panel--signup .auth-password .auth-control {
    padding-right: 40px;
  }
  .auth-panel--signup .auth-password__toggle {
    right: 10px;
    width: 20px;
    height: 20px;
  }
  .auth-panel--signup .auth-field label {
    font-size: 13px;
  }
}

@media (max-width: 600px) {
  .auth-page--signup {
    min-height: 812px;
    padding-top: 188px;
  }
  .auth-page--signup .auth-brand {
    height: 188px;
    min-height: 188px;
  }
  .auth-page--signup .auth-panel--signup {
    height: 624px;
    min-height: 624px;
    padding: 32px 24px;
    gap: 0;
    overflow: hidden;
  }
  .auth-signup-form {
    gap: var(--space-8);
  }
  .auth-signup-inputs {
    gap: var(--space-5);
  }
  .auth-terms-check {
    min-height: 23px;
    align-items: center;
    font-size: 12px;
    line-height: 20.2px;
    white-space: nowrap;
  }
  .auth-terms-check input {
    width: 16px;
    height: 16px;
    flex-basis: 16px;
    margin: 0;
  }
  .auth-panel--signup .auth-field__hint {
    font-size: 12px;
    line-height: 15px;
  }
  .auth-panel--signup .auth-button {
    height: 44px;
    font-size: 14px;
  }
  .auth-signup-login {
    margin-top: var(--space-8);
    font-size: 13px;
    line-height: 20.2px;
  }
  .auth-page--signup .auth-legal {
    padding-top: var(--space-6);
  }
}

/* Email verification after sign-up */
.auth-page--email-verification .auth-brand {
  flex-basis: 50%;
}
.auth-panel--email-verification {
  flex: 0 0 50%;
  width: 50%;
  align-items: center;
}
.auth-email-verification {
  width: 100%;
  max-width: 460px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-8);
  text-align: center;
}
.auth-email-verification__icon {
  width: 56px;
  height: 56px;
  display: grid;
  place-items: center;
  border-radius: var(--radius-full);
  background: var(--interactive-soft);
}
.auth-email-verification__icon img {
  width: 22px;
  height: 18px;
}
.auth-email-verification__title {
  width: 100%;
  display: grid;
  gap: var(--space-3);
}
.auth-email-verification__title h2,
.auth-email-verification__title p,
.auth-email-verification__actions p {
  margin: 0;
}
.auth-email-verification__title h2 {
  color: var(--text-primary);
  font: var(--font-weight-light) var(--font-size-display-lg) /
    var(--line-height-display-lg) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-display-lg);
}
.auth-email-verification__title p {
  color: var(--text-secondary);
  font: var(--font-weight-regular) var(--font-size-body-lg) /
    var(--line-height-body-lg) var(--font-family-primary);
}
.auth-email-verification__title strong {
  color: var(--text-primary);
  font-weight: var(--font-weight-bold);
}
.auth-email-verification__actions {
  width: 100%;
  display: grid;
  gap: var(--space-5);
}
.auth-email-verification__actions p {
  color: var(--text-disabled);
  font: var(--font-weight-regular) var(--font-size-body-sm) /
    var(--line-height-body-sm) var(--font-family-primary);
}
.auth-email-verification__back {
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  color: var(--interactive-default);
  font: var(--font-weight-medium) var(--font-size-label-md) /
    var(--line-height-label-md) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-label-md);
  text-decoration: none;
}
.auth-email-verification__back img {
  width: 16px;
  height: 16px;
}

/* OTP verification styles matching Figma */
.auth-otp-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-6, 24px);
}

.auth-otp-field {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-2, 8px);
}

.auth-otp-label {
  font: var(--font-weight-medium, 500) 14px/18px var(--font-family-primary);
  color: var(--text-primary, #142624);
  text-align: left;
}

.auth-otp-inputs {
  display: flex;
  gap: 12px;
  justify-content: space-between;
  width: 100%;
}

.auth-otp-box {
  width: 64px;
  height: 64px;
  border-radius: var(--radius-lg, 14px);
  border: 1px solid var(--border-subtle, #cdd6d4);
  background: var(--surface-primary);
  color: var(--text-primary, #142624);
  font: 600 24px/32px var(--font-family-primary, "Lexend", sans-serif);
  text-align: center;
  outline: none;
  transition: all 0.15s ease-in-out;
  padding: 0;
  box-sizing: border-box;
}

.auth-otp-box:hover:not(:disabled):not(:focus) {
  border-color: var(--border-strong, #94a3b8);
}

.auth-otp-box:focus {
  border: 2px solid var(--interactive-default, #0f766e);
  box-shadow: none;
}

.auth-otp-box--filled {
  border-color: var(--interactive-default, #0f766e);
}

.auth-otp-box--error {
  border: 1.5px solid var(--danger-default, #d9383a) !important;
  color: var(--danger-default, #d9383a);
  box-shadow: none !important;
}

.auth-otp-error-msg {
  color: var(--danger-default, #d9383a);
  font: 400 13px/18px var(--font-family-primary);
  text-align: left;
  margin-top: 4px;
  width: 100%;
}

.auth-otp-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
  color: var(--text-secondary, #4d6663);
}

.auth-otp-resend {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 500;
}

.auth-otp-resend--disabled {
  color: var(--text-disabled, #758a87);
  opacity: 0.8;
}

.auth-otp-resend-btn {
  background: none;
  border: none;
  padding: 0;
  color: var(--interactive-default, #0f766e);
  font: 500 13px var(--font-family-primary);
  cursor: pointer;
  text-decoration: none;
}

.auth-otp-resend-btn:hover:not(:disabled) {
  text-decoration: underline;
}

.auth-otp-resend-btn:disabled {
  color: var(--text-disabled, #758a87);
  cursor: not-allowed;
  opacity: 0.7;
}

.auth-otp-back-btn {
  background: none;
  border: none;
  padding: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--interactive-default, #0f766e);
  font: 500 15px var(--font-family-primary);
  cursor: pointer;
  text-decoration: none;
  margin-top: 4px;
}

.auth-otp-back-btn:hover {
  text-decoration: underline;
}

.auth-otp-back-btn img {
  width: 16px;
  height: 16px;
}

@media (max-width: 1023px) {
  .auth-page--email-verification .auth-brand {
    flex: none;
  }
  .auth-panel--email-verification {
    flex: 1 1;
    width: 100%;
    align-items: center;
    padding: 56px 80px;
    justify-content: center;
  }
  .auth-email-verification {
    max-width: 500px;
    flex: 1 1;
  }
  .auth-email-verification__back {
    height: 44px;
  }
}

@media (max-width: 600px) {
  .auth-page--email-verification {
    min-height: 812px;
    padding-top: 227px;
  }
  .auth-page--email-verification .auth-brand {
    height: 227px;
    min-height: 227px;
  }
  .auth-page--email-verification .auth-panel--email-verification {
    height: 585px;
    min-height: 585px;
    padding: 32px 24px;
    justify-content: space-between;
    overflow: hidden;
  }
  .auth-email-verification {
    max-width: none;
    gap: var(--space-8);
  }
  .auth-email-verification__back {
    height: 40px;
    gap: 6px;
  }
  .auth-email-verification__actions .auth-button {
    height: 40px;
  }
  .auth-otp-inputs {
    gap: 8px;
  }
  .auth-otp-box {
    width: 46px;
    height: 48px;
    font-size: 20px;
    border-radius: 10px;
  }
  .auth-otp-form {
    gap: 16px;
  }
  .auth-page--email-verification .auth-legal {
    flex: none;
    padding-top: var(--space-6);
  }
}

/* Keep typed and browser-autofilled credentials on the same themed surface. */
.auth-control {
  caret-color: var(--auth-text-primary);
}
.auth-control:-webkit-autofill,
.auth-control:-webkit-autofill:hover,
.auth-control:-webkit-autofill:focus {
  -webkit-text-fill-color: var(--auth-text-primary);
  -webkit-box-shadow: 0 0 0 1000px var(--surface-primary) inset;
  caret-color: var(--auth-text-primary);
}
html[data-theme="dark"] .auth-password__toggle img,
html[data-theme="dark"] .auth-button--secondary img {
  filter: brightness(0) invert(1);
}
`, "",{"version":3,"sources":["webpack://./src/styles/auth.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,2CAA2C;EAC3C,2CAA2C;EAC3C,wCAAwC;EACxC,4CAA4C;EAC5C,2CAA2C;EAC3C,8CAA8C;EAC9C,kDAAkD;EAClD,oCAAoC;EACpC,oCAAoC;EACpC,0CAA0C;EAC1C,kDAAkD;EAClD,kCAAkC;EAClC,kCAAkC;EAClC,uCAAuC;AACzC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,kCAAkC;EAClC,6BAA6B;EAC7B,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B;;;;;GAKC;EACD,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,SAAS;AACX;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,SAAS;AACX;AACA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,0CAA0C;EAC1C,oCAAoC;EACpC,oCAAoC;EACpC,aAAa;EACb,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,WAAW;AACb;AACA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,WAAW;EACX,UAAU;AACZ;AACA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,WAAW;EACX,UAAU;EACV,YAAY;EACZ,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,8BAA8B;EAC9B,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,oCAAoC;EACpC,eAAe;EACf,aAAa;EACb,+BAA+B;EAC/B,kCAAkC;EAClC,+BAA+B;AACjC;AACA;EACE,gCAAgC;EAChC,UAAU;AACZ;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,eAAe;EACf,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,sCAAsC;EACtC,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,qCAAqC;EACrC;;yBAEuB;AACzB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,YAAY;EACZ,SAAS;EACT,oCAAoC;EACpC,eAAe;EACf,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,yBAAyB;EACzB,kBAAkB;EAClB,iDAAiD;EACjD,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,WAAW;EACX,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,+BAA+B;EAC/B,oCAAoC;EACpC,yCAAyC;AAC3C;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,QAAQ;EACR,iCAAiC;EACjC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE;IACE,sCAAsC;EACxC;EACA;IACE,mCAAmC;IACnC,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,gDAAgD;IAChD,0BAA0B;EAC5B;EACA;IACE,YAAY;IACZ,+BAA+B;EACjC;EACA;IACE,mCAAmC;IACnC,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,oCAAoC;IACpC,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,uBAAuB;IACvB,SAAS;IACT,2BAA2B;EAC7B;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,WAAW;IACX,UAAU;EACZ;EACA;IACE,YAAY;IACZ,aAAa;IACb,WAAW;IACX,WAAW;IACX,UAAU;IACV,YAAY;EACd;EACA;IACE,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,uBAAuB;IACvB,2BAA2B;IAC3B,SAAS;EACX;EACA;IACE,SAAO;EACT;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,sBAAsB;EACxB;EACA;;IAEE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,SAAS;EACX;EACA;;IAEE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,eAAe;IACf,gCAAgC;IAChC,oCAAoC;IACpC,eAAe;EACjB;EACA;IACE,SAAS;EACX;EACA;IACE,YAAY;IACZ,eAAe;IACf,oCAAoC;IACpC,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB;;;;;KAKC;EACH;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;;IAEE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;EACZ;EACA;IACE,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,4BAA4B;EAC9B;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,QAAQ;IACR,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,QAAQ;IACR,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;AACF;AACA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,eAAe;EACjB;AACF;AACA;EACE,gBAAgB;EAChB,oCAAoC;AACtC;AACA;EACE,yDAA+D;AACjE;AACA;EACE,yDAAgE;AAClE;AACA;EACE,yDAA4D;AAC9D;AACA;EACE;IACE,yDAAkE;EACpE;EACA;IACE,yDAAmE;EACrE;AACF;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;AACd;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oCAAoC;EACpC,8BAA8B;EAC9B,+BAA+B;EAC/B,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE;IACE,SAAO;IACP,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,YAAY;IACZ,oCAAoC;IACpC,eAAe;EACjB;AACF;AACA;EACE;IACE,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,8BAA8B;EAChC;EACA;IACE,UAAU;EACZ;EACA;IACE,QAAQ;EACV;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,UAAU;IACV,WAAW;IACX,YAAY;EACd;EACA;IACE,YAAY;IACZ,QAAQ;IACR,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,0BAA0B;EAC1B;4DAC0D;EAC1D,gDAAgD;AAClD;AACA;EACE,SAAS;EACT,4BAA4B;EAC5B;yDACuD;AACzD;AACA;EACE,0BAA0B;EAC1B,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,2BAA2B;EAC3B;4DAC0D;EAC1D,gDAAgD;AAClD;AACA;EACE,WAAW;AACb;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,4BAA4B;EAC5B;8BAC4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,SAAO;EACT;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,SAAO;EACT;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;;IAEE,aAAa;IACb,iBAAiB;IACjB,8BAA8B;IAC9B,gBAAgB;EAClB;EACA;IACE,SAAO;IACP,mBAAmB;EACrB;EACA;;IAEE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,mCAAmC;EACrC;EACA;IACE,UAAU;IACV,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,SAAS;AACX;AACA;EACE,0BAA0B;EAC1B;4DAC0D;EAC1D,gDAAgD;AAClD;AACA;EACE,4BAA4B;EAC5B;yDACuD;AACzD;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,SAAO;EACT;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;IACb,iBAAiB;IACjB,8BAA8B;IAC9B,gBAAgB;EAClB;EACA;IACE,SAAO;EACT;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,UAAU;EACZ;AACF;;AAEA,YAAY;AACZ;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B;yDACuD;EACvD,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,wCAAwC;AAC1C;AACA;;;EAGE,iCAAiC;AACnC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B;yDACuD;AACzD;AACA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,uBAAuB;EACvB;0DACwD;EACxD,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,eAAe;IACf,mCAAmC;IACnC,+BAA+B;IAC/B,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,MAAM;IACN,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,0BAA0B;IAC1B,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,qCAAqC;AACrC;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;;;EAGE,SAAS;AACX;AACA;EACE,0BAA0B;EAC1B;4DAC0D;EAC1D,gDAAgD;AAClD;AACA;EACE,4BAA4B;EAC5B;yDACuD;AACzD;AACA;EACE,0BAA0B;EAC1B,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B;yDACuD;AACzD;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC;EACjC;0DACwD;EACxD,8CAA8C;EAC9C,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,2CAA2C;AAC3C;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,yEAAyE;EACzE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,+CAA+C;EAC/C,kCAAkC;EAClC,mCAAmC;EACnC,oEAAoE;EACpE,kBAAkB;EAClB,aAAa;EACb,iCAAiC;EACjC,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,qDAAqD;EACrD,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,6DAA6D;EAC7D,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,8CAA8C;EAC9C,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,0CAA0C;EAC1C,yCAAyC;EACzC,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0CAA0C;EAC1C,yCAAyC;EACzC,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,SAAO;IACP,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,SAAO;EACT;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;IAC9B,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,QAAQ;EACV;EACA;IACE,YAAY;EACd;EACA;IACE,QAAQ;EACV;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA,8EAA8E;AAC9E;EACE,qCAAqC;AACvC;AACA;;;EAGE,iDAAiD;EACjD,6DAA6D;EAC7D,qCAAqC;AACvC;AACA;;EAEE,+BAA+B;AACjC","sourcesContent":[":root {\n  --auth-brand-start: var(--brand-gradient-start);\n  --auth-brand-mid: var(--brand-gradient-mid);\n  --auth-brand-end: var(--brand-gradient-end);\n  --auth-text-primary: var(--text-primary);\n  --auth-text-secondary: var(--text-secondary);\n  --auth-text-disabled: var(--text-secondary);\n  --auth-interactive: var(--interactive-default);\n  --auth-interactive-hover: var(--interactive-hover);\n  --auth-danger: var(--danger-default);\n  --auth-border: var(--border-default);\n  --auth-border-subtle: var(--border-subtle);\n  --auth-surface-secondary: var(--surface-secondary);\n  --auth-radius-md: var(--radius-md);\n  --auth-radius-lg: var(--radius-lg);\n  --auth-font: var(--font-family-primary);\n}\n* {\n  box-sizing: border-box;\n}\n.auth-page {\n  min-height: 100vh;\n  display: flex;\n  background: var(--surface-primary);\n  font-family: var(--auth-font);\n  color: var(--auth-text-primary);\n}\n.auth-brand {\n  position: relative;\n  flex: 1 1 50%;\n  min-width: 0;\n  min-height: 100vh;\n  padding: 80px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  background: linear-gradient(\n    90deg,\n    var(--auth-brand-start),\n    var(--auth-brand-mid) 45%,\n    var(--auth-brand-end)\n  );\n  color: #fff;\n}\n.auth-brand__logo {\n  position: relative;\n  z-index: 1;\n  width: 262px;\n  height: 57px;\n}\n.auth-brand__mobile-logo {\n  display: none;\n}\n.auth-brand__message {\n  position: relative;\n  z-index: 1;\n  display: grid;\n  gap: 24px;\n}\n.auth-brand__message h1 {\n  margin: 0;\n  max-width: 720px;\n  font-size: 54px;\n  line-height: 64px;\n  letter-spacing: -2px;\n  font-weight: 700;\n}\n.auth-brand__message p {\n  margin: 0;\n  max-width: 760px;\n  font-size: 18px;\n  line-height: 28.8px;\n}\n.auth-brand__features {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  gap: 16px;\n}\n.auth-feature {\n  min-width: 0;\n  flex: 0 1 230px;\n  padding: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: var(--auth-radius-lg);\n  background: rgba(255, 255, 255, 0.1);\n  display: grid;\n  gap: 2px;\n}\n.auth-feature__icon {\n  width: 32px;\n  height: 32px;\n  margin-bottom: 10px;\n  display: grid;\n  place-items: center;\n  border-radius: var(--auth-radius-md);\n  background: rgba(255, 255, 255, 0.13);\n}\n.auth-feature__icon img {\n  width: 18px;\n  height: 18px;\n}\n.auth-feature strong {\n  font-size: 16px;\n  line-height: 20.8px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n.auth-feature small {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 12px;\n  line-height: 16.8px;\n  white-space: nowrap;\n}\n.auth-orb {\n  position: absolute;\n  display: block;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n}\n.auth-orb--one {\n  width: 516px;\n  height: 516px;\n  left: -178px;\n  top: -205px;\n}\n.auth-orb--two {\n  width: 140px;\n  height: 140px;\n  left: 666px;\n  right: auto;\n  top: -60px;\n}\n.auth-orb--three {\n  width: 416px;\n  height: 416px;\n  left: 528px;\n  right: auto;\n  top: 758px;\n  bottom: auto;\n  background: rgba(5, 78, 104, 0.12);\n}\n.auth-panel {\n  flex: 1 1 50%;\n  min-width: 0;\n  min-height: 100vh;\n  position: relative;\n  padding: 64px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 20px;\n  background: var(--surface-primary);\n}\n.auth-form {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n.auth-title {\n  display: grid;\n  gap: 8px;\n}\n.auth-title h2 {\n  margin: 0;\n  font-weight: 300;\n  font-size: 48px;\n  line-height: 55.2px;\n  letter-spacing: -0.96px;\n}\n.auth-title p {\n  margin: 0;\n  color: var(--auth-text-secondary);\n  font-size: 14px;\n  line-height: 21.7px;\n}\n.auth-inputs {\n  display: grid;\n  gap: 16px;\n}\n.auth-field {\n  display: grid;\n  gap: 6px;\n}\n.auth-field__label-row {\n  display: flex;\n  align-items: center;\n  min-height: 18px;\n}\n.auth-field label {\n  font-size: 14px;\n  line-height: 18px;\n  font-weight: 500;\n}\n.auth-field label span {\n  color: var(--auth-danger);\n}\n.auth-field__action {\n  margin-left: auto;\n  border: 0;\n  padding: 0;\n  color: var(--auth-interactive);\n  background: none;\n  font: 400 14px/18px var(--auth-font);\n  cursor: pointer;\n  text-decoration: none;\n}\n.auth-control {\n  width: 100%;\n  height: 48px;\n  border: 1px solid var(--border-strong);\n  border-radius: var(--auth-radius-lg);\n  padding: 0 16px;\n  outline: none;\n  color: var(--auth-text-primary);\n  background: var(--surface-primary);\n  font: 400 16px var(--auth-font);\n}\n.auth-control::placeholder {\n  color: var(--auth-text-disabled);\n  opacity: 1;\n}\n.auth-control:hover:not(:disabled):not(:focus) {\n  border-color: var(--border-strong);\n}\n.auth-control:focus {\n  border-width: 2px;\n  border-color: var(--auth-interactive);\n  box-shadow: none;\n}\n.auth-control--error {\n  border-color: var(--auth-danger);\n}\n.auth-password {\n  position: relative;\n}\n.auth-password .auth-control {\n  padding-right: 48px;\n}\n.auth-password__toggle {\n  position: absolute;\n  right: 13px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 24px;\n  height: 24px;\n  padding: 2px;\n  border: 0;\n  background: none;\n  cursor: pointer;\n}\n.auth-password__toggle img {\n  width: 20px;\n  height: 20px;\n}\n.auth-field__error {\n  color: var(--auth-danger);\n  font-size: 12px;\n  line-height: 16px;\n}\n.auth-check {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--auth-text-secondary);\n  font-size: 14px;\n  cursor: pointer;\n}\n.auth-check input {\n  appearance: none;\n  width: 20px;\n  height: 20px;\n  margin: 0;\n  border: 1.5px solid var(--auth-border);\n  border-radius: 4px;\n  background: var(--surface-primary);\n  cursor: pointer;\n}\n.auth-check input:checked {\n  border-color: var(--auth-interactive);\n  background: var(--auth-interactive)\n    url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='none' stroke='white' stroke-width='2' d='m2 6 2.5 2.5L10 3'/%3E%3C/svg%3E\")\n    center/12px no-repeat;\n}\n.auth-actions {\n  display: grid;\n  gap: 14px;\n}\n.auth-button {\n  height: 48px;\n  border: 0;\n  border-radius: var(--auth-radius-lg);\n  padding: 0 24px;\n  font: 500 16px var(--auth-font);\n  cursor: pointer;\n}\n.auth-button--primary {\n  color: var(--on-interactive-primary);\n  background: var(--auth-interactive);\n}\n.auth-button--primary:hover {\n  background: var(--auth-interactive-hover);\n}\n.auth-button--loading {\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  cursor: wait !important;\n  opacity: 0.85;\n  pointer-events: none;\n}\n.auth-button__spinner {\n  display: inline-block;\n  width: 18px;\n  height: 18px;\n  border: 2px solid rgba(255, 255, 255, 0.35);\n  border-top-color: #ffffff;\n  border-radius: 50%;\n  animation: auth-button-spin 0.65s linear infinite;\n  margin-right: 8px;\n  flex: 0 0 18px;\n}\n@keyframes auth-button-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n.auth-divider {\n  height: 1px;\n  background: var(--auth-border-subtle);\n}\n.auth-button--secondary {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  color: var(--auth-text-primary);\n  border: 1px solid var(--auth-border);\n  background: var(--auth-surface-secondary);\n}\n.auth-button--secondary img {\n  width: 20px;\n  height: 20px;\n}\n.auth-signup {\n  display: flex;\n  justify-content: center;\n  gap: 4px;\n  margin: 0;\n  color: var(--auth-text-secondary);\n  font-size: 14px;\n  line-height: 21.7px;\n}\n.auth-link {\n  color: var(--auth-interactive);\n  text-decoration: none;\n  font-weight: 500;\n}\n.auth-legal {\n  position: absolute;\n  bottom: 32px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 4px;\n  color: var(--auth-text-secondary);\n  font-size: 13px;\n  white-space: nowrap;\n}\n.auth-legal a {\n  color: var(--auth-interactive);\n  text-decoration: none;\n}\n@media (min-width: 1024px) and (max-width: 1579px) {\n  .auth-page--login .auth-brand {\n    padding-inline: clamp(32px, 5vw, 64px);\n  }\n  .auth-page--login .auth-brand__message h1 {\n    font-size: clamp(38px, 3.4vw, 48px);\n    line-height: 1.12;\n    letter-spacing: -1.2px;\n  }\n  .auth-page--login .auth-brand__features {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: clamp(8px, 1vw, 14px);\n  }\n  .auth-page--login .auth-feature {\n    min-width: 0;\n    padding: clamp(10px, 1vw, 14px);\n  }\n  .auth-page--login .auth-feature strong {\n    font-size: clamp(12px, 0.9vw, 14px);\n    line-height: 1.35;\n    white-space: normal;\n    overflow-wrap: anywhere;\n  }\n  .auth-page--login .auth-feature small {\n    font-size: clamp(10px, 0.76vw, 12px);\n    line-height: 1.4;\n    white-space: normal;\n    overflow-wrap: anywhere;\n  }\n}\n@media (max-width: 1023px) {\n  .auth-page {\n    flex-direction: column;\n  }\n  .auth-brand {\n    flex: none;\n    width: 100%;\n    min-height: 282px;\n    padding: 54px 48px 48px;\n    gap: 24px;\n    justify-content: flex-start;\n  }\n  .auth-brand__message {\n    gap: 12px;\n  }\n  .auth-brand__message h1 {\n    font-size: 36px;\n    line-height: 44px;\n    letter-spacing: -1.5px;\n  }\n  .auth-brand__message p {\n    max-width: 700px;\n    font-size: 15px;\n    line-height: 22px;\n    opacity: 0.9;\n  }\n  .auth-brand__features {\n    display: none;\n  }\n  .desktop-only {\n    display: none;\n  }\n  .auth-orb--one {\n    width: 380px;\n    height: 380px;\n    left: -100px;\n    top: -120px;\n  }\n  .auth-orb--two {\n    width: 74px;\n    height: 74px;\n    left: 736px;\n    right: auto;\n    top: -38px;\n  }\n  .auth-orb--three {\n    width: 300px;\n    height: 300px;\n    left: 520px;\n    right: auto;\n    top: 110px;\n    bottom: auto;\n  }\n  .auth-panel {\n    flex: none;\n    width: 100%;\n    min-height: 742px;\n    padding: 85px 80px 56px;\n    justify-content: flex-start;\n    gap: 32px;\n  }\n  .auth-form {\n    flex: 1;\n  }\n  .auth-title h2 {\n    font-size: 40px;\n    line-height: 46px;\n    letter-spacing: -0.8px;\n  }\n  .auth-title p,\n  .auth-signup {\n    font-size: 13px;\n    line-height: 20.2px;\n  }\n  .auth-inputs {\n    gap: 20px;\n  }\n  .auth-field label,\n  .auth-field__action {\n    font-size: 13px;\n  }\n  .auth-control {\n    height: 40px;\n    padding: 0 12px;\n    border-color: var(--auth-border);\n    border-radius: var(--auth-radius-md);\n    font-size: 14px;\n  }\n  .auth-actions {\n    gap: 16px;\n  }\n  .auth-button {\n    height: 44px;\n    padding: 0 16px;\n    border-radius: var(--auth-radius-md);\n    font-size: 14px;\n  }\n  .auth-legal {\n    position: static;\n    transform: none;\n    justify-content: center;\n    padding-top: 24px;\n  }\n}\n@media (max-width: 600px) {\n  .auth-page {\n    min-height: 812px;\n    position: relative;\n    padding-top: 227px;\n    background: linear-gradient(\n      90deg,\n      var(--auth-brand-start),\n      var(--auth-brand-mid) 45%,\n      var(--auth-brand-end)\n    );\n  }\n  .auth-brand {\n    position: absolute;\n    inset: 0 0 auto;\n    height: 227px;\n    min-height: 227px;\n    padding: 48px 20px 0;\n    align-items: center;\n    background: transparent;\n  }\n  .auth-brand__logo,\n  .auth-brand__message {\n    display: none;\n  }\n  .auth-brand__mobile-logo {\n    position: relative;\n    z-index: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n  }\n  .auth-brand__mobile-logo img:first-child {\n    width: 57px;\n    height: 57px;\n  }\n  .auth-brand__mobile-logo img:last-child {\n    width: 196px;\n    height: 21px;\n  }\n  .auth-orb--one {\n    width: 236px;\n    height: 236px;\n    left: -82px;\n    top: -56px;\n  }\n  .auth-orb--two {\n    width: 126px;\n    height: 126px;\n    right: -56px;\n    top: -53px;\n  }\n  .auth-orb--three {\n    display: none;\n  }\n  .auth-panel {\n    position: relative;\n    z-index: 2;\n    min-height: 585px;\n    padding: 32px 24px;\n    border-radius: 32px 32px 0 0;\n  }\n  .auth-form {\n    gap: 32px;\n  }\n  .auth-title h2 {\n    font-size: 32px;\n    line-height: 36.8px;\n    letter-spacing: -0.64px;\n  }\n  .auth-check {\n    gap: 6px;\n    font-size: 13px;\n  }\n  .auth-check input {\n    width: 16px;\n    height: 16px;\n  }\n  .auth-button {\n    height: 40px;\n    padding: 0 12px;\n    font-size: 13px;\n  }\n  .auth-button--secondary img {\n    width: 16px;\n    height: 16px;\n  }\n  .auth-signup {\n    gap: 6px;\n    white-space: nowrap;\n  }\n  .auth-legal {\n    padding-top: 24px;\n    gap: 8px;\n  }\n}\n@media (max-width: 374px) {\n  .auth-panel {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n  .auth-signup {\n    white-space: normal;\n    flex-wrap: wrap;\n  }\n}\n.auth-orb {\n  border-radius: 0;\n  background: center/contain no-repeat;\n}\n.auth-orb--one {\n  background-image: url(\"../assets/images/auth/orb-top-left.svg\");\n}\n.auth-orb--two {\n  background-image: url(\"../assets/images/auth/orb-top-right.svg\");\n}\n.auth-orb--three {\n  background-image: url(\"../assets/images/auth/orb-large.svg\");\n}\n@media (max-width: 600px) {\n  .auth-orb--one {\n    background-image: url(\"../assets/images/auth/orb-mobile-left.svg\");\n  }\n  .auth-orb--two {\n    background-image: url(\"../assets/images/auth/orb-mobile-right.svg\");\n  }\n}\n\n/* Forgot-password composition */\n.auth-panel--reset {\n  flex: 0 0 50%;\n  width: 50%;\n}\n.auth-form--reset {\n  height: 512px;\n}\n.auth-email-control {\n  position: relative;\n}\n.auth-email-control > img {\n  display: none;\n  position: absolute;\n  z-index: 1;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 20px;\n  height: 20px;\n}\n.auth-actions--reset {\n  gap: 20px;\n}\n.auth-back-link {\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border-radius: var(--auth-radius-lg);\n  color: var(--auth-interactive);\n  font: 500 16px var(--auth-font);\n  text-decoration: none;\n}\n.auth-back-link img {\n  width: 20px;\n  height: 20px;\n}\n@media (max-width: 1023px) {\n  .auth-page--reset .auth-panel--reset {\n    flex: 1;\n    width: 100%;\n  }\n  .auth-form--reset {\n    height: auto;\n  }\n  .auth-email-control > img {\n    display: block;\n  }\n  .auth-email-control .auth-control {\n    padding-left: 40px;\n  }\n  .auth-actions--reset {\n    gap: 16px;\n  }\n  .auth-back-link {\n    height: 44px;\n    border-radius: var(--auth-radius-md);\n    font-size: 14px;\n  }\n}\n@media (max-width: 600px) {\n  .auth-page--reset .auth-panel--reset {\n    height: 585px;\n    min-height: 585px;\n    overflow: hidden;\n    justify-content: space-between;\n  }\n  .auth-page--reset .auth-form--reset {\n    flex: none;\n  }\n  .auth-page--reset .auth-field {\n    gap: 4px;\n  }\n  .auth-page--reset .auth-control {\n    height: 32px;\n    padding-left: 34px;\n    padding-right: 10px;\n    font-size: 13px;\n  }\n  .auth-page--reset .auth-email-control > img {\n    left: 10px;\n    width: 16px;\n    height: 16px;\n  }\n  .auth-page--reset .auth-back-link {\n    height: 40px;\n    gap: 6px;\n    font-size: 13px;\n  }\n  .auth-page--reset .auth-back-link img {\n    width: 16px;\n    height: 16px;\n  }\n}\n\n/* Reset-link confirmation */\n.auth-panel--confirmation {\n  align-items: center;\n}\n.auth-confirmation {\n  width: 480px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--space-8);\n  text-align: center;\n}\n.auth-success-ring {\n  width: 64px;\n  height: 64px;\n  display: grid;\n  place-items: center;\n  border-radius: var(--radius-full);\n  background: var(--interactive-soft);\n}\n.auth-success-ring img {\n  width: 24px;\n  height: 24px;\n}\n.auth-confirmation__title {\n  width: 100%;\n  display: grid;\n  gap: var(--space-3);\n}\n.auth-confirmation__title h2 {\n  margin: 0;\n  color: var(--text-primary);\n  font: var(--font-weight-light) var(--font-size-display-lg) /\n    var(--line-height-display-lg) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-display-lg);\n}\n.auth-confirmation__title p {\n  margin: 0;\n  color: var(--text-secondary);\n  font: var(--font-weight-regular) var(--font-size-body-sm) /\n    var(--line-height-body-sm) var(--font-family-primary);\n}\n.auth-confirmation__title strong {\n  color: var(--text-primary);\n  font-weight: var(--font-weight-bold);\n}\n.auth-confirmation__actions {\n  width: 100%;\n  display: grid;\n  gap: var(--space-4);\n}\n.auth-confirmation__actions p {\n  margin: 0;\n  color: var(--text-tertiary);\n  font: var(--font-weight-regular) var(--font-size-caption-md) /\n    var(--line-height-caption-md) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-caption-md);\n}\n.auth-confirmation > .auth-divider {\n  width: 100%;\n}\n\n/* Set-new-password composition */\n.auth-form--new-password {\n  gap: var(--space-8);\n}\n.auth-field__hint {\n  height: 16px;\n  color: var(--text-secondary);\n  font: var(--font-weight-regular) var(--font-size-caption-md) / 16px\n    var(--font-family-primary);\n}\n.auth-actions--new-password {\n  gap: var(--space-6);\n}\n.auth-button:disabled {\n  cursor: not-allowed;\n  background: var(--interactive-disabled);\n  color: var(--on-interactive-disabled);\n}\n\n@media (max-width: 1023px) {\n  .auth-panel--confirmation {\n    justify-content: flex-start;\n  }\n  .auth-confirmation {\n    width: 100%;\n    max-width: 500px;\n    flex: 1;\n  }\n  .auth-panel--new-password {\n    justify-content: flex-start;\n  }\n  .auth-form--new-password {\n    flex: 1;\n  }\n  .auth-actions--new-password {\n    gap: var(--space-6);\n  }\n}\n@media (max-width: 600px) {\n  .auth-page--confirmation .auth-panel--confirmation,\n  .auth-page--new-password .auth-panel--new-password {\n    height: 585px;\n    min-height: 585px;\n    justify-content: space-between;\n    overflow: hidden;\n  }\n  .auth-page--confirmation .auth-confirmation {\n    flex: 1;\n    gap: var(--space-8);\n  }\n  .auth-page--confirmation .auth-legal,\n  .auth-page--new-password .auth-legal {\n    flex: none;\n  }\n  .auth-confirmation__title p {\n    max-width: 327px;\n  }\n  .auth-page--new-password .auth-form--new-password {\n    flex: none;\n  }\n  .auth-page--new-password .auth-inputs {\n    gap: var(--space-4);\n  }\n  .auth-page--new-password .auth-field {\n    gap: var(--space-1);\n  }\n  .auth-page--new-password .auth-control {\n    height: var(--control-sm);\n    padding-left: 10px;\n    padding-right: 36px;\n    font-size: var(--font-size-body-sm);\n  }\n  .auth-page--new-password .auth-password__toggle {\n    right: 8px;\n    width: 20px;\n    height: 20px;\n  }\n  .auth-page--new-password .auth-password__toggle img {\n    width: 16px;\n    height: 16px;\n  }\n  .auth-page--new-password .auth-actions--new-password {\n    gap: var(--space-6);\n  }\n}\n\n/* Password-reset success */\n.auth-panel--password-success {\n  align-items: center;\n}\n.auth-password-success {\n  width: 440px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--space-8);\n  text-align: center;\n}\n.auth-password-success__icon {\n  width: 72px;\n  height: 72px;\n  display: grid;\n  place-items: center;\n  border-radius: var(--radius-full);\n  background: var(--interactive-soft);\n}\n.auth-password-success__icon img {\n  width: 22px;\n  height: 22px;\n}\n.auth-password-success__copy {\n  width: 100%;\n  display: grid;\n  gap: var(--space-3);\n}\n.auth-password-success__copy h2,\n.auth-password-success__copy p {\n  margin: 0;\n}\n.auth-password-success__copy h2 {\n  color: var(--text-primary);\n  font: var(--font-weight-light) var(--font-size-display-lg) /\n    var(--line-height-display-lg) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-display-lg);\n}\n.auth-password-success__copy p {\n  color: var(--text-secondary);\n  font: var(--font-weight-regular) var(--font-size-body-sm) /\n    var(--line-height-body-sm) var(--font-family-primary);\n}\n\n@media (max-width: 1023px) {\n  .auth-panel--password-success {\n    justify-content: flex-start;\n  }\n  .auth-password-success {\n    width: 100%;\n    max-width: 500px;\n    flex: 1;\n  }\n  .auth-password-success__copy h2 {\n    font-size: 40px;\n    line-height: 46px;\n    letter-spacing: -0.8px;\n  }\n  .auth-password-success__copy p {\n    font-size: 13px;\n    line-height: 20.2px;\n  }\n}\n\n@media (max-width: 600px) {\n  .auth-page--password-success .auth-panel--password-success {\n    height: 585px;\n    min-height: 585px;\n    justify-content: space-between;\n    overflow: hidden;\n  }\n  .auth-page--password-success .auth-password-success {\n    flex: 1;\n  }\n  .auth-password-success__copy h2 {\n    font-size: 32px;\n    line-height: 36.8px;\n    letter-spacing: -0.64px;\n  }\n  .auth-page--password-success .auth-legal {\n    flex: none;\n  }\n}\n\n/* Sign-up */\n.auth-page--signup .auth-brand {\n  flex: 0 0 51.111%;\n}\n.auth-panel--signup {\n  flex: 1 1 auto;\n  align-items: stretch;\n}\n.auth-signup-form {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-6);\n}\n.auth-signup-inputs {\n  display: grid;\n  gap: var(--space-4);\n}\n.auth-terms-check {\n  min-height: 24px;\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-2);\n  color: var(--text-primary);\n  font: var(--font-weight-regular) var(--font-size-body-sm) /\n    var(--line-height-body-sm) var(--font-family-primary);\n  cursor: pointer;\n}\n.auth-terms-check input {\n  width: 20px;\n  height: 20px;\n  flex: 0 0 20px;\n  margin: 2px 0 0;\n  accent-color: var(--interactive-default);\n}\n.auth-terms-check a,\n.auth-signup-login a,\n.auth-text-button {\n  color: var(--interactive-default);\n}\n.auth-terms-check a {\n  text-decoration: underline;\n}\n.auth-signup-login {\n  margin: 0;\n  text-align: center;\n  color: var(--text-secondary);\n  font: var(--font-weight-regular) var(--font-size-body-sm) /\n    var(--line-height-body-sm) var(--font-family-primary);\n}\n.auth-signup-login a {\n  margin-left: var(--space-1);\n  font-weight: var(--font-weight-medium);\n  text-decoration: none;\n}\n.auth-signup-form--otp {\n  gap: var(--space-8);\n}\n.auth-signup-otp-actions {\n  display: grid;\n  gap: var(--space-4);\n}\n.auth-text-button {\n  border: 0;\n  background: transparent;\n  font: var(--font-weight-medium) var(--font-size-label-md) /\n    var(--line-height-label-md) var(--font-family-primary);\n  cursor: pointer;\n}\n\n@media (max-width: 1023px) {\n  .auth-page--signup .auth-brand {\n    flex: none;\n  }\n  .auth-panel--signup {\n    gap: var(--space-8);\n  }\n  .auth-signup-form {\n    gap: var(--space-8);\n  }\n  .auth-signup-inputs {\n    gap: var(--space-5);\n  }\n  .auth-panel--signup .auth-control {\n    height: 40px;\n    padding: 0 12px;\n    border-color: var(--border-default);\n    border-radius: var(--radius-md);\n    font-size: 14px;\n  }\n  .auth-panel--signup .auth-password .auth-control {\n    padding-right: 40px;\n  }\n  .auth-panel--signup .auth-password__toggle {\n    right: 10px;\n    width: 20px;\n    height: 20px;\n  }\n  .auth-panel--signup .auth-field label {\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 600px) {\n  .auth-page--signup {\n    min-height: 812px;\n    padding-top: 188px;\n  }\n  .auth-page--signup .auth-brand {\n    height: 188px;\n    min-height: 188px;\n  }\n  .auth-page--signup .auth-panel--signup {\n    height: 624px;\n    min-height: 624px;\n    padding: 32px 24px;\n    gap: 0;\n    overflow: hidden;\n  }\n  .auth-signup-form {\n    gap: var(--space-8);\n  }\n  .auth-signup-inputs {\n    gap: var(--space-5);\n  }\n  .auth-terms-check {\n    min-height: 23px;\n    align-items: center;\n    font-size: 12px;\n    line-height: 20.2px;\n    white-space: nowrap;\n  }\n  .auth-terms-check input {\n    width: 16px;\n    height: 16px;\n    flex-basis: 16px;\n    margin: 0;\n  }\n  .auth-panel--signup .auth-field__hint {\n    font-size: 12px;\n    line-height: 15px;\n  }\n  .auth-panel--signup .auth-button {\n    height: 44px;\n    font-size: 14px;\n  }\n  .auth-signup-login {\n    margin-top: var(--space-8);\n    font-size: 13px;\n    line-height: 20.2px;\n  }\n  .auth-page--signup .auth-legal {\n    padding-top: var(--space-6);\n  }\n}\n\n/* Email verification after sign-up */\n.auth-page--email-verification .auth-brand {\n  flex-basis: 50%;\n}\n.auth-panel--email-verification {\n  flex: 0 0 50%;\n  width: 50%;\n  align-items: center;\n}\n.auth-email-verification {\n  width: 100%;\n  max-width: 460px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--space-8);\n  text-align: center;\n}\n.auth-email-verification__icon {\n  width: 56px;\n  height: 56px;\n  display: grid;\n  place-items: center;\n  border-radius: var(--radius-full);\n  background: var(--interactive-soft);\n}\n.auth-email-verification__icon img {\n  width: 22px;\n  height: 18px;\n}\n.auth-email-verification__title {\n  width: 100%;\n  display: grid;\n  gap: var(--space-3);\n}\n.auth-email-verification__title h2,\n.auth-email-verification__title p,\n.auth-email-verification__actions p {\n  margin: 0;\n}\n.auth-email-verification__title h2 {\n  color: var(--text-primary);\n  font: var(--font-weight-light) var(--font-size-display-lg) /\n    var(--line-height-display-lg) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-display-lg);\n}\n.auth-email-verification__title p {\n  color: var(--text-secondary);\n  font: var(--font-weight-regular) var(--font-size-body-lg) /\n    var(--line-height-body-lg) var(--font-family-primary);\n}\n.auth-email-verification__title strong {\n  color: var(--text-primary);\n  font-weight: var(--font-weight-bold);\n}\n.auth-email-verification__actions {\n  width: 100%;\n  display: grid;\n  gap: var(--space-5);\n}\n.auth-email-verification__actions p {\n  color: var(--text-disabled);\n  font: var(--font-weight-regular) var(--font-size-body-sm) /\n    var(--line-height-body-sm) var(--font-family-primary);\n}\n.auth-email-verification__back {\n  width: 100%;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-2);\n  color: var(--interactive-default);\n  font: var(--font-weight-medium) var(--font-size-label-md) /\n    var(--line-height-label-md) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-label-md);\n  text-decoration: none;\n}\n.auth-email-verification__back img {\n  width: 16px;\n  height: 16px;\n}\n\n/* OTP verification styles matching Figma */\n.auth-otp-form {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-6, 24px);\n}\n\n.auth-otp-field {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--space-2, 8px);\n}\n\n.auth-otp-label {\n  font: var(--font-weight-medium, 500) 14px/18px var(--font-family-primary);\n  color: var(--text-primary, #142624);\n  text-align: left;\n}\n\n.auth-otp-inputs {\n  display: flex;\n  gap: 12px;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.auth-otp-box {\n  width: 64px;\n  height: 64px;\n  border-radius: var(--radius-lg, 14px);\n  border: 1px solid var(--border-subtle, #cdd6d4);\n  background: var(--surface-primary);\n  color: var(--text-primary, #142624);\n  font: 600 24px/32px var(--font-family-primary, \"Lexend\", sans-serif);\n  text-align: center;\n  outline: none;\n  transition: all 0.15s ease-in-out;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.auth-otp-box:hover:not(:disabled):not(:focus) {\n  border-color: var(--border-strong, #94a3b8);\n}\n\n.auth-otp-box:focus {\n  border: 2px solid var(--interactive-default, #0f766e);\n  box-shadow: none;\n}\n\n.auth-otp-box--filled {\n  border-color: var(--interactive-default, #0f766e);\n}\n\n.auth-otp-box--error {\n  border: 1.5px solid var(--danger-default, #d9383a) !important;\n  color: var(--danger-default, #d9383a);\n  box-shadow: none !important;\n}\n\n.auth-otp-error-msg {\n  color: var(--danger-default, #d9383a);\n  font: 400 13px/18px var(--font-family-primary);\n  text-align: left;\n  margin-top: 4px;\n  width: 100%;\n}\n\n.auth-otp-info {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  align-items: center;\n  font-size: 14px;\n  line-height: 20px;\n  color: var(--text-secondary, #4d6663);\n}\n\n.auth-otp-resend {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.auth-otp-resend--disabled {\n  color: var(--text-disabled, #758a87);\n  opacity: 0.8;\n}\n\n.auth-otp-resend-btn {\n  background: none;\n  border: none;\n  padding: 0;\n  color: var(--interactive-default, #0f766e);\n  font: 500 13px var(--font-family-primary);\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.auth-otp-resend-btn:hover:not(:disabled) {\n  text-decoration: underline;\n}\n\n.auth-otp-resend-btn:disabled {\n  color: var(--text-disabled, #758a87);\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.auth-otp-back-btn {\n  background: none;\n  border: none;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--interactive-default, #0f766e);\n  font: 500 15px var(--font-family-primary);\n  cursor: pointer;\n  text-decoration: none;\n  margin-top: 4px;\n}\n\n.auth-otp-back-btn:hover {\n  text-decoration: underline;\n}\n\n.auth-otp-back-btn img {\n  width: 16px;\n  height: 16px;\n}\n\n@media (max-width: 1023px) {\n  .auth-page--email-verification .auth-brand {\n    flex: none;\n  }\n  .auth-panel--email-verification {\n    flex: 1;\n    width: 100%;\n    align-items: center;\n    padding: 56px 80px;\n    justify-content: center;\n  }\n  .auth-email-verification {\n    max-width: 500px;\n    flex: 1;\n  }\n  .auth-email-verification__back {\n    height: 44px;\n  }\n}\n\n@media (max-width: 600px) {\n  .auth-page--email-verification {\n    min-height: 812px;\n    padding-top: 227px;\n  }\n  .auth-page--email-verification .auth-brand {\n    height: 227px;\n    min-height: 227px;\n  }\n  .auth-page--email-verification .auth-panel--email-verification {\n    height: 585px;\n    min-height: 585px;\n    padding: 32px 24px;\n    justify-content: space-between;\n    overflow: hidden;\n  }\n  .auth-email-verification {\n    max-width: none;\n    gap: var(--space-8);\n  }\n  .auth-email-verification__back {\n    height: 40px;\n    gap: 6px;\n  }\n  .auth-email-verification__actions .auth-button {\n    height: 40px;\n  }\n  .auth-otp-inputs {\n    gap: 8px;\n  }\n  .auth-otp-box {\n    width: 46px;\n    height: 48px;\n    font-size: 20px;\n    border-radius: 10px;\n  }\n  .auth-otp-form {\n    gap: 16px;\n  }\n  .auth-page--email-verification .auth-legal {\n    flex: none;\n    padding-top: var(--space-6);\n  }\n}\n\n/* Keep typed and browser-autofilled credentials on the same themed surface. */\n.auth-control {\n  caret-color: var(--auth-text-primary);\n}\n.auth-control:-webkit-autofill,\n.auth-control:-webkit-autofill:hover,\n.auth-control:-webkit-autofill:focus {\n  -webkit-text-fill-color: var(--auth-text-primary);\n  -webkit-box-shadow: 0 0 0 1000px var(--surface-primary) inset;\n  caret-color: var(--auth-text-primary);\n}\nhtml[data-theme=\"dark\"] .auth-password__toggle img,\nhtml[data-theme=\"dark\"] .auth-button--secondary img {\n  filter: brightness(0) invert(1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
